export default "__VITE_ASSET__S3Gvtmd2__"